import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PearlHarborAvalancheReelModel} from "./PearlHarborAvalancheReelModel";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {PearlHarborReelView} from "./PearlHarborReelView";
import {PearlHarbor} from "../PearlHarbor";
import {TimelineLite} from "gsap";
import {ISymbolData, PearlHarborModel} from "../server/PearlHarborModel";

export class PearlHarborReelAreaView extends PIXI.Container implements StageLayer {

    private _mainReelModels: PearlHarborAvalancheReelModel[];
    public landingTLs : TimelineLite[] = [];
    constructor() {
        super();
        this.init();
    }

    public reInit(symbols:ISymbolData[][]){
        for (let i: number = 0; i < this._mainReelModels.length; i++) {
            const reel = this._mainReelModels[i];
            reel.clear();
            reel.init(symbols[i]);
        }
    }

    private init(): void {
        this.name = "ReelAreaView";
        this._mainReelModels = [];
        const data:PearlHarborModel = PearlHarbor.model,
             reels:ISymbolData[][] = data.isRestore?(data.isNextNormal?data.afterCollapseSymbolsData:data.allSymbolsData):data.allSymbolsData;
        let tempReel: ISymbolData[];

        for (let i: number = 0; i < PearlHarborGameConfig.defaultGameAreaSize.length; i++) {
            tempReel = [];
            const reelModel: PearlHarborAvalancheReelModel = new PearlHarborAvalancheReelModel(i);
            this._mainReelModels.push(reelModel);
            this.addChild(<PearlHarborReelView>reelModel.reelView);
            for (let j: number = 0; j < reels[i].length; j++) {
                tempReel.push(reels[i][j]);
            }
            reelModel.init(tempReel);
        }

        for (let j: number = 0; j < this._mainReelModels.length; j++) {
            this.addChild(this._mainReelModels[j].bigSymbolView);
            this.addChild(this._mainReelModels[j].specialSymbolView);
        }

        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "reelAreaMask";
        mainReelsMask.beginFill(0xFFFF0B, 0.5);
        mainReelsMask.drawRect(-PearlHarborGameConfig.symbolWidth, -PearlHarborGameConfig.symbolHeight*0.5, this.getReelAreaWidth() + PearlHarborGameConfig.symbolWidth, this.getReelAreaHeight());
        mainReelsMask.position = PearlHarborGameConfig.MAIN_REELS_VIEW_MASK_POSITION;

        // todo enable reel area masking
        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;

        this.position.set(57, 162);
    }

    private getReelAreaWidth(): number {
        return (PearlHarborGameConfig.symbolWidth * PearlHarborGameConfig.totalReels) + 20;
    }

    private getReelAreaHeight(): number {
        return PearlHarborGameConfig.symbolHeight * PearlHarborGameConfig.totalSymsPerReel;
    }

    public setMode(mode: string): void {
    }

    get mainReelModels(): PearlHarborAvalancheReelModel[] {
        return this._mainReelModels;
    }
}